import { Component, OnInit, ViewChild, DebugNode, Inject } from '@angular/core';
import { SchoolregistrationService } from './schoolregistration.service';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { global } from '../../shared/global';
import { Router, ActivatedRoute } from "@angular/router";
import { SchoolRegistration } from '../Models/schoolregistration.model';
import { DOCUMENT } from '@angular/common';
declare var $: any;


@Component({
  selector: 'app-schoolregistration',
  templateUrl: './schoolregistration.component.html',
  styleUrls: ['./schoolregistration.component.css']
})
export class SchoolregistrationComponent implements OnInit {
  @ViewChild('schoolForm') schoolForm: NgForm;
  data: SchoolRegistration;
  dropDownData: any;
  responseData: any;
  schoolList: Array<any>;
  isDesc: boolean;
  column: string;
  p: number = 1;
  pageLimit = global.pageLimit;
  submitted: boolean;
  searchtext: any;
  HashCode: any;
  boards: any;
  states: any;
  cities: any;
  btnsubmittext = "Add";
  totalPages = 10;
  totalCollege: any;
  citynameid:any;

  constructor(private service: SchoolregistrationService, private toastr: ToastrService, private spinner: NgxSpinnerService, private router: Router, private rout: ActivatedRoute, @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    if (localStorage.length == 0) {
      this.router.navigate(['/aciadmin']);
      return;
    }
    this.data = new SchoolRegistration();
    $("#searchtext").val("");
    this.fillBoard();
    this.getSchoolList(this.p);
    this.fillState();
    //this.fillCity(this.data.StateID);
    document.getElementById('YearID').addEventListener('change', () => {
      this.getSchoolList(this.p);
    });
  }

  fillBoard() {
    const data = {
    };
    this.service.fillBoard(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.boards = this.dropDownData.dropdownlist;
        this.boards.splice(0, 1);
      });
  }

  fillState() {
    const data = {
    };
    this.service.fillState(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.states = this.dropDownData.dropdownlist;
        this.data.StateID = 12;
        this.fillCity();
      });
  }

  fillCity() {
    const data = {
      stateID: this.data.StateID
    };

    this.service.fillCity(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.cities = this.dropDownData.dropdownlist;
        if (this.data.CityID == 0 || this.data.CityID == undefined)
          this.data.CityID = 0;
      });
  }

  blockSpecialChar(e) {
    var k;
    document.all ? k = e.keyCode : k = e.which;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || (k >= 48 && k <= 57) || k == 91 || k == 93 || k == 45 || k == 32 || k == 92 || k == 47);
  }

  getSchoolList(page) {
    this.spinner.show();
    this.p = page;
    var search = "";
    if ($("#searchtext").val() != undefined || $("#searchtext").val() != null || $("#searchtext").val() != "") {
      search = $("#searchtext").val();
    }
    const data = {
      SearchText: search,
      OffSet: (this.p - 1) * this.pageLimit,
      pagelimit: this.pageLimit,
      YearID : localStorage.getItem("YearID")
    };
    this.service.getSchoolList(data)
      .subscribe(data => {
        this.responseData = data; 
        this.spinner.hide();
        this.schoolList = undefined;
        if (this.responseData.tokenStatus == false) {
          localStorage.clear();
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/aciadmin']);
        }
        if (!this.responseData.userRightsStatus) {
          this.toastr.error(this.responseData.message);
          //this.router.navigate(['/aciadmin']);
          return;
        }
        if (this.responseData.status == false) {
          //this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.show();
          this.schoolList = this.responseData.SchoolLists;
          // this.totalPages = this.responseData.totalPages;
          this.totalCollege = this.responseData.totalCount;
          this.spinner.hide();
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }

  onSubmit(data) {
    this.submitted = true;
    this.data.Board = "";
    for (var i = 0; i < this.boards.length; i++) {
      var j = $('#chkBoard' + i).is(":checked");
      if (j == true) {
        if (this.data.Board == "")
          this.data.Board += ",";
        this.data.Board += this.boards[i]["value"] + "@#";
      }
    }
    if (this.data.Board == "" || (this.data.StateID == 0 || this.data.StateID == undefined) || (this.data.CityID == 0 || this.data.CityID == undefined)) {
      return;
    }
    if (this.schoolForm.valid) {
      this.spinner.show();
      this.data.YearID= parseInt(localStorage.getItem("yearID"));
      this.service.saveSchool(this.data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.tokenStatus == false) {
            localStorage.clear();
            this.toastr.error(this.responseData.message);
            this.router.navigate(['/aciadmin']);
          }
          if (!this.responseData.userRightsStatus) {
            this.toastr.error(this.responseData.message);
            //this.router.navigate(['/aciadmin']);
            return;
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.getSchoolList(this.p);
            this.toastr.success(this.responseData.message);
            this.resetForm();
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/aciadmin']);
        });
    }
  }
  editSchool(HashCode) {
    this.spinner.show();
    const data = {
      HashCode: HashCode,
      YearID : localStorage.getItem("YearID")
    };
    this.fillBoard();
    this.service.getSchoolByID(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        if (this.responseData.tokenStatus == false) {
          this.toastr.error(this.responseData.message);
          return
        }
        if (!this.responseData.userRightsStatus) {
          this.toastr.error(this.responseData.message);
          // this.router.navigate(['/aciadmin']);
          return;
        }
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.hide();
          this.data = this.responseData;
          this.citynameid = this.responseData.CityID;
        //  setTimeout(() => {
          //  this.fillCity(this.responseData.StateID);
            // this.fillSchoolName(this.responseData.StateID, this.cityid, this.area);
          //}, 1000);
          this.data.CityID = this.citynameid;
          for (var i = 0; i < this.boards.length; i++) {
            if (this.data.Board.includes(this.boards[i]["value"])) {
              $('#chkBoard' + i).prop("checked", true);
            }
          }
          this.btnsubmittext = "Update";
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }
  deleteSchool(HashCode) {
    var a = confirm("Are you sure you want to delete ?");
    if (a) {
      const data = {
        HashCode: HashCode
      }
      this.spinner.show();
      this.service.deleteSchool(data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.tokenStatus == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          if (!this.responseData.userRightsStatus) {
            this.toastr.error(this.responseData.message);
            //  this.router.navigate(['/aciadmin']);
            return;
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.toastr.success(this.responseData.message);
            this.getSchoolList(this.p);
            this.resetForm();
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/aciadmin']);
        });
    }
  }
  sortBy(field: string) {
    this.isDesc = !this.isDesc;
    this.column = field;
    let direction = this.isDesc ? 1 : -1;

    this.schoolList.sort(function (a, b) {
      if (a[field] < b[field]) {
        return -1 * direction;
      }
      else if (a[field] > b[field]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }
  setpage() {
    this.p = 1;
  }
  resetForm() {
    this.data.ID = 0;
    this.data.HashCode = null;
    this.data.SchoolName = null;
    this.data.UdiseNo = null;
    this.data.MailID = null;
    this.data.Address = null;
    this.data.MobileNo = null;
    this.data.Area = null;
    this.fillBoard();
    this.data.StateID = 12;
    this.data.Area = null;
    this.data.CityID = 0;
    this.data.Pincode = null;
    this.submitted = false;
    this.btnsubmittext = "Add";
  }

}
